<template>
<div class="container">
  <div v-if="view === 'list'" class="row mb-5 pb-5">
    <div class="col">
      <table class="table table-striped table-hover small">
        <thead>
          <tr>
            <th width="10%">Rule ID</th>
            <th width="10%">Priority</th>
            <th width="35%">Conditions</th>
            <th width="35%">Routings</th>
            <th width="10%" class="text-end"><a href="#" @click.prevent="onAddRule" v-b-tooltip title="Add Rule"><i class="fas fa-plus"></i></a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!rules || rules.length == 0">
            <td colspan="5" class="py-3 text-warning fw-bold text-center">No routing rules defined for merchant account</td>
          </tr>
          <tr v-for="rule in rules" :key="rule.ruleId">
            <td>{{rule.ruleId}}</td>
            <td>{{rule.priority}}</td>
            <td>{{rule.conditionsDescription}}</td>
            <td>{{getRoutingsText(rule)}}</td>
            <td class="text-center">
              <a href="#" @click.prevent="onEditRule(rule)" v-b-tooltip.hover title="Edit Rule"><i class="fas fa-edit mx-2"></i></a>
              <a href="#" @click.prevent="onDeleteRule(rule)" v-b-tooltip.hover title="Delete Rule"><i class="fas fa-trash text-danger"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <merchant-proc-rule-form v-if="view === 'form'" :mxa="mxa" :rule-obj="selectedRule"
     @saved="onRuleSaved" @cancelled="view = 'list'">
  </merchant-proc-rule-form>
  
  <b-modal id="confirmDelRule" title="Confirm Deletion" @ok="deleteRule">
    <div class="text-center">
      <span class="fw-bold text-danger">Are you sure you want to delete rule {{selectedRule ? selectedRule.ruleId : ""}} ?</span>
    </div>
  </b-modal>
  
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
import MerchantProcRuleForm from '../components/MerchantProcRuleForm.vue'
export default {
  name: 'MerchantProcRules',
  mixins: [HelpersMixin],
  components: {MerchantProcRuleForm},
  props: {
    mxa: Object
  },
  data () {
    return {
      rules: [],
      selectedRule: null,
      view: 'list'
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    getRules: function () {
      this.axios.get('/ax/merchantprocrules/' + this.mxa.merchantId + "/" + this.mxa.accountId)
      .then (response => {
        this.rules = response.data
      })
      .catch(error => this.handleError(error))
    },
    getRoutingsText: function (rule) {
      if (rule && rule.procRoutings) {
        var routingsText = ''
        for (const routing of rule.procRoutings) {
          if (routingsText.length > 0) {
              routingsText = routingsText + ', '
          }
          routingsText = routingsText + routing.procId
        }
        return routingsText
      } else {
        return 'No Routings Defined'
      }
    },
    onAddRule: function () {
      this.selectedRule = null
      this.view = 'form'
    },
    onEditRule: function (rule) {
      this.selectedRule = rule
      this.view = 'form'
    },
    onRuleSaved: function () {
      this.view = 'list'
      this.getRules()
    },
    onDeleteRule: function (rule) {
      this.selectedRule = rule
      this.$bvModal.show('confirmDelRule')
    },
    deleteRule: function () {
      this.axios.delete('/ax/merchantprocrule/' + this.selectedRule.hashKey + '/' + this.selectedRule.ruleId)
      .then(() => {
        this.$bvModal.hide('confirmDelRule')
        this.getRules()
        this.selected = null
        this.$toasted.success(this.selectedRule.ruleId + ' successfully deleted')
        this.selectedRule = null
      })
      .catch(error => this.handleError(error))
    }
  }
}
</script>